import { assign, filter, find, findIndex } from 'lodash';

export type OrderAscType = 'asc';

export type OrderDescType = 'desc';

export type OrderNoneType = 'null';

export type SortStack = Array<Sorter>;

export type SortOrder = OrderAscType | OrderDescType | OrderNoneType;

export const SORT_ASC: OrderAscType = 'asc';

export const SORT_DESC: OrderDescType = 'desc';

export const SORT_NO_SORT: OrderNoneType = 'null';

export interface Sorter {
  readonly key: string;
  readonly type: 'axis';
  order: SortOrder;
}

export type SorterPartial = Partial<Sorter>;

export default class SortState {
  private stack: SortStack = [];

  add(entry: Sorter): number {
    return this.stack.push(entry);
  }

  update(key: string, type: 'axis', order: SortOrder) {
    assign(find(this.stack, { key, type }), { order });
    return this;
  }

  remove(key: string) {
    return this;
  }

  filter(args: SorterPartial) {
    return filter(this.stack, args);
  }

  has(key: string, type: 'axis') {
    return findIndex(this.stack, { key, type }) >= 0;
  }

  getStack(): SortStack {
    return this.stack;
  }
}
